import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import times from 'lodash/times';
import { useSelector } from 'react-redux';

// components
import { Dropdown } from '@tcc/crate';

// constants
import { selectIdPrefix } from 'constants/values';

// util
import { getCropBasedMessage, getMessage } from 'util/locale';
import { createProductOptions } from 'products/productOptionsUtil';
import { getActiveCropId } from 'current/currentSelectors';

const baseString = 'vra-seed-product-inputs';
let classString = classNames({
  [`${baseString}`]: true
});
const SeedProductInputs = ({
  numSeedProductInputs,
  onChangeSearchQuery,
  onSelectSeedProduct,
  seedProductInputs
}) => {
  const cropId = useSelector(getActiveCropId);
  let firstProduct;

  const inputs = times(numSeedProductInputs, (index) => {
    const inputNum = index + 1;
    const selectId = `${selectIdPrefix}${inputNum}`;
    const input = seedProductInputs[selectId];

    const currentProductId = input.currentProductId;
    let products = input.products || [];
    const product = products.find(product => product.id === currentProductId);
    const name = product && product.name;
    if(index === 0) {firstProduct = currentProductId;}

    let inputClassString = classNames({
      [`${baseString}__input`]: true
    });

    const loadOptions = (input, onOptionsLoaded) => {
      const receiveOptions = (products) => {
        let crateOptions = createProductOptions(products);
        if(index !== 0) {
          crateOptions = crateOptions.filter(product => product.id !== firstProduct);
        }
        onOptionsLoaded(crateOptions);
      };

      onChangeSearchQuery({ fragment: input, selectId, receiveOptions });
    };

    const setValue = (_, id) => {
      onSelectSeedProduct({
        currentProductId: id,
        oldProductId: currentProductId,
        products: seedProductInputs,
        selectId
      });
    };

    return (
      <li
        className={inputClassString}
        key={selectId}>
        <Dropdown
          label={getCropBasedMessage({ key: 'product', cropId })}
          loadOptions={loadOptions}
          placeholder={getMessage('placeholder-text__search')}
          selectedId={currentProductId}
          setValue={setValue}
          testId={`${baseString}-${index}`} // ${baseString}-1 or -2
          type='AsyncDropdown'
          value={name}
        />
      </li>
    );
  });

  return (
    <ul className={classString}>
      {inputs}
    </ul>
  );
};
SeedProductInputs.propTypes = {
  numSeedProductInputs: propTypes.number.isRequired,
  onChangeSearchQuery: propTypes.func.isRequired,
  onSelectSeedProduct: propTypes.func.isRequired,
  seedProductInputs: propTypes.object.isRequired,
  showTestedLabels: propTypes.bool
};
export default SeedProductInputs;
